import type { Interval } from '../../../../../common/types';

export { getDynamicMarkerStyles } from './dynamic-styles';

export const getLabel = ({
	intervals,
	targetIntervalId,
	isLabelVisible,
}: {
	intervals: ReadonlyArray<Interval>;
	targetIntervalId: string | undefined;
	isLabelVisible: boolean;
}) => {
	if (!isLabelVisible) {
		return null;
	}
	if (targetIntervalId !== undefined) {
		const interval = intervals.find(({ id }: Interval) => id === targetIntervalId);
		return interval ? interval.name : null;
	}
	return intervals.map(({ name }: Interval) => name).join(', ');
};
